// Banner Images to be display in MSITE on landing page (/shop/men  OR /shop/women ....) based on below value.
export const MSITE_PLATFORM = {
  WEB: false,
  MSITE: true,
  KIOSK: false,
  APP: false,
  ANDROID: false,
  IOS: false,
  ALL: true
};

export const DESKTOP_PLATFORM = {
  WEB: true,
  MSITE: false,
  KIOSK: false,
  APP: false,
  ANDROID: false,
  IOS: false,
  ALL: true
};
